// extracted by mini-css-extract-plugin
export default {"container":"iD-z","dimension":"jD-z","dimensionLabels":"kD-z"};